import { createSlice } from "@reduxjs/toolkit";
import { userExtraReducers } from "./userExtraReducers";
import { userReducers } from "./userReducers";

const initialState = {
  userAuthToken: null,
  tokenData: null,
  userProfile: [],
};
const slice = createSlice({
  name: "user",
  initialState,
  reducers: userReducers,
  extraReducers: userExtraReducers,
});

export const { LOG_OUT } = slice.actions;
export const { SET_AUTH } = slice.actions;

export const { reducer: userSlice } = slice;
